import { Config, ConfigEnvironment } from './ConfigType';

export const config: Config = {
  env: ConfigEnvironment.PRODUCTION,
  release: 'fc3b92e94445b6cb71bd2418931989f6c978b6a8',
  sentryDSN: undefined,
  websiteURL: 'http://teslaeesti.com/',
  apiURLFrontend: '/api_api/',
  plausible: {
    siteId: 'teslaeesti.com',
    url: 'https://plausible.freeyourmusic.com/'
  }
};
